module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "EPI"
  }, [_vm._v("… it started like a "), _c('span', {
    staticClass: "italic-1"
  }, [_vm._v("guilty thing")])]), _vm._v(" "), _c('p', {
    staticClass: "EPI"
  }, [_vm._v("Upon a fearful summons.")]), _vm._v(" "), _c('p', {
    staticClass: "EPISS"
  }, [_vm._v("Shakespeare, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Hamlet")]), _vm._v(", Act 1, Scene 1")]), _vm._v(" "), _c('p', {
    staticClass: "EPI"
  }, [_vm._v("Blank misgivings of a Creature")]), _vm._v(" "), _c('p', {
    staticClass: "EPI"
  }, [_vm._v("Moving about in worlds not realised,")]), _vm._v(" "), _c('p', {
    staticClass: "EPI"
  }, [_vm._v("High instincts before which our mortal Nature")]), _vm._v(" "), _c('p', {
    staticClass: "EPI"
  }, [_vm._v("Did tremble like a guilty thing surprised …")]), _vm._v(" "), _c('p', {
    staticClass: "EPISS"
  }, [_vm._v("Wordsworth, ‘Intimations of Immortality’")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0825b0b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0